'use strict';

require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
require("moduleFold/validatori/scripts/index.js");
var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");


/**
 * Campo di tipo entity su entity esterna
 * 
 * @class  
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {Valida} Valida
 */
function BSSMultilocalita(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bssmultilocalita', 
        //extends: 'bssselect',
        template: require("./bssmultilocalita.html"),
        controller: ["$scope", "$filter", "$timeout", "$http", "$sce", "ErrorManager", "DSFactory", "FieldFactory", "Valida", require("./BssMultilocalitaController")],
        wrapper: ['BssErrorWrapper', "BssReadOnlyWrapper", "bsslegendwrapper"],
        defaultOptions: {
            ngModelElAttrs: {
                'cssCategory': 'bssmultilocalita'
            },
        }
    }));
}

module.exports = BSSMultilocalita;